module.exports = __webpack_public_path__ + "media/images/home/usecase-physical-e11a7deaa3337e81d4aa1c80cb823d6e.jpg";